/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Create_EventInputs */

const th_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างอีเวนต์`)
};

const en_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an event`)
};

const ja_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを作成`)
};

const zh_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建赛事`)
};

const es_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un evento`)
};

const pt_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar um evento`)
};

const id_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat acara`)
};

const fr_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un événement`)
};

const tl_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumawa ng event`)
};

const vi_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo sự kiện`)
};

const ko_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 만들기`)
};

const de_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event anlegen`)
};

const ru_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать событие`)
};

const tr_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik oluştur`)
};

const it_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea evento`)
};

const pl_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz wydarzenie`)
};

const uk_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створити подію`)
};

const hi_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन बनाएँ`)
};

const ar_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء فعالية`)
};

const ms_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta acara`)
};

const bn_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন তৈরি করুন`)
};

const zh_tw2_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立賽事`)
};

const zh_hk2_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立賽事`)
};

const ur_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ بنائیں`)
};

const fa_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساختن رویداد`)
};

const sw_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua tukio`)
};

const nl_home_create_event = /** @type {(inputs: Home_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement aanmaken`)
};

/**
* | output |
* | --- |
* | "Create an event" |
*
* @param {Home_Create_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_create_event = /** @type {((inputs?: Home_Create_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Create_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_create_event(inputs)
	if (locale === "ja") return ja_home_create_event(inputs)
	if (locale === "zh") return zh_home_create_event(inputs)
	if (locale === "es") return es_home_create_event(inputs)
	if (locale === "pt") return pt_home_create_event(inputs)
	if (locale === "id") return id_home_create_event(inputs)
	if (locale === "fr") return fr_home_create_event(inputs)
	if (locale === "tl") return tl_home_create_event(inputs)
	if (locale === "vi") return vi_home_create_event(inputs)
	if (locale === "ko") return ko_home_create_event(inputs)
	if (locale === "de") return de_home_create_event(inputs)
	if (locale === "ru") return ru_home_create_event(inputs)
	if (locale === "tr") return tr_home_create_event(inputs)
	if (locale === "it") return it_home_create_event(inputs)
	if (locale === "pl") return pl_home_create_event(inputs)
	if (locale === "uk") return uk_home_create_event(inputs)
	if (locale === "hi") return hi_home_create_event(inputs)
	if (locale === "ar") return ar_home_create_event(inputs)
	if (locale === "ms") return ms_home_create_event(inputs)
	if (locale === "bn") return bn_home_create_event(inputs)
	if (locale === "zh-TW") return zh_tw2_home_create_event(inputs)
	if (locale === "zh-HK") return zh_hk2_home_create_event(inputs)
	if (locale === "ur") return ur_home_create_event(inputs)
	if (locale === "fa") return fa_home_create_event(inputs)
	if (locale === "sw") return sw_home_create_event(inputs)
	if (locale === "nl") return nl_home_create_event(inputs)
	return en_home_create_event(inputs)
});